import React, { useState } from 'react';
import './PaymentsDeeplinkGenerator.css';

import paypalIcon from '../icons/paypal.svg';
import venmoIcon from '../icons/venmo.svg';
import zelleIcon from '../icons/zelle.svg';
import cashappIcon from '../icons/cashapp.svg';
import applepayIcon from '../icons/apple-pay.svg';


const paymentIcons = {
  PAYPAL: paypalIcon,  
  VENMO: venmoIcon, 
  ZELLE: zelleIcon, 
  CASHAPP: cashappIcon, 
  APPLEPAY: applepayIcon,
};

const PaymentsDeeplinkGenerator = ({type, id, name}) => {
  const [message, setMessage] = useState(''); // State to show instructions
  let deeplink = '';
  let fallbackUrl = '';

  // Function to copy the ID to the clipboard
  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value)
      .then(() => {
        const messageText = type === 'ZELLE' ? 
          "Open your favorite banking app to Zelle someone money using the email or phone copied to your clipboard." :
          "Use the email or phone copied to your clipboard to send a payment.";
        setMessage(messageText);
      })
      .catch(err => {
        console.error('Could not copy text:', err);
      });
  };
  // Determine the deep link and fallback URL based on the type
  switch (type) {
      case 'PAYPAL':
          deeplink = `paypal://send?recipient=${id}`;
          fallbackUrl = `https://www.paypal.com/paypalme/${id}`;
          return (
              <>
                <a href={deeplink} onClick={(e) => {
                    e.preventDefault(); // Prevent default behavior
                    window.location = deeplink;
                    setTimeout(() => { window.location = fallbackUrl; }, 1000);
                }}>
                    <img 
                        src={paymentIcons[type]} 
                        alt={`${name} icon`} 
                        className="icon" 
                    />
                </a>
              </>
          );
      case 'VENMO':
          deeplink = `venmo://paycharge?txn=pay&recipients=${id}`;
          fallbackUrl = `https://venmo.com/${id}`;
          return (
              <>
                <a href={deeplink} onClick={(e) => {
                    e.preventDefault(); // Prevent default behavior
                    window.location = deeplink;
                    setTimeout(() => { window.location = fallbackUrl; }, 1000);
                }}>
                    <img 
                        src={paymentIcons[type]} 
                        alt={`${name} icon`} 
                        className="icon" 
                    />
                </a>
              </>
          );
      case 'CASHAPP':
          deeplink = `cashapp://$${id}`;
          fallbackUrl = `https://cash.app/$${id}`;
          return (
              <>
                <a href={deeplink} onClick={(e) => {
                    e.preventDefault(); // Prevent default behavior
                    window.location = deeplink;
                    setTimeout(() => { window.location = fallbackUrl; }, 1000);
                }}>
                    <img 
                        src={paymentIcons[type]} 
                        alt={`${name} icon`} 
                        className="icon" 
                    />
                </a>
              </>
          );
      case 'APPLEPAY':
          // Create iMessage deeplink with the phone number
          deeplink = `imessage://${id}`;
          return (
              <>
                <a href={deeplink} onClick={(e) => {
                    e.preventDefault();
                    window.location = deeplink;
                }}>
                    <img src={paymentIcons[type]} alt={`${name} icon`} className="icon" />
                </a>
                {message && <div className="message">{message}</div>}
              </>
          );
      case 'ZELLE':
        return (
            <>
              <a href="#" onClick={(e) => { e.preventDefault(); copyToClipboard(id); }}>
                <img src={paymentIcons[type]} alt={`${name} icon`} className="icon" />
              </a>
              <br/>
              {message && <><div className="message">{message}</div></>}
            </>
          );
          default:
          throw new Error('Unsupported payment type');
  }
}

export default PaymentsDeeplinkGenerator;